module.exports = __webpack_public_path__ + "img/event-log.57a728c4.svg";